import { SfSelectOption } from 'ngx-smart-form';
import { Product, ProductType } from '../app/requests/models/product';
import { PraticaAggregator } from '../app/settings/header-requests/pratica-aggregator';
import { Soggetto } from '../app/anagraphics/models/cms-document-fields';

export class Pratica {
  channel: string;
  erogante: string;
  garante: string;
  denomination: string;
  state: StatoPratica;
  id: string;
  praticaCode: string;
  piva: string;
  target: Target;
  user: string;
  userCreator: string;
  process?: { richiesta: string; istruttoria?: string };
  products: ProductType[];
  progress?: Partial<PraticaProgress>;
  dataPrenotazioneStipula?: null | number;
  tipoSoggetto: Soggetto;
  type: PraticaType;
  dataCambioStatoPratica: number;
  constructor(data: IPratica, prodotto?: Product) {
    this.id = data.id;
    this.praticaCode = data.codicePratica;
    this.channel = data.canale;
    this.erogante = data.erogante;
    this.garante = data.garante;
    this.denomination = data.denominazione;
    this.state = data.stato;
    this.piva = data.piva;
    this.target = data.target;
    this.user = data.user;
    this.userCreator = data.userCreator;
    this.process = data.process;
    this.products = data.prodotti;
    this.progress = data.progress;
    this.dataPrenotazioneStipula = data.dataPrenotazioneStipula;
    this.tipoSoggetto = data.tipoSoggetto;
    this.type = data.tipo;
    this.dataCambioStatoPratica = data.dataCambioStatoPratica;
  }
}

export interface IPratica {
  canale: string;
  codicePratica: string;
  id: string;
  piva: string;
  stato: StatoPratica;
  target: Target;
  user: string;
  userCreator: string;
  denominazione: string;
  erogante: string;
  garante: string;
  process: { richiesta: string; istruttoria?: string };
  prodotti: ProductType[];
  progress?: Partial<PraticaProgress>;
  dataPrenotazioneStipula?: null | number;
  timestampIns: number;
  timestampMod: number;
  tipoSoggetto: Soggetto;
  tipo: PraticaType;
  dataCambioStatoPratica: number;
}

export interface PraticaSearchDTO {
  assegnataA: string;
  canale: string;
  codicePratica: string;
  denominazione: string;
  partitaIvaCF: string;
  target: string;
  statiPratica: string[];
  erogante: string;
  garante: string;
  inbox: boolean;
  dateStipula: string; //iso string
  prodotti: ProductType;
  praticaTypes: PraticaType;
  tipoSoggetto: Soggetto;
  importo: number;
}

export enum Target {
  IMPRESE = 'imprese',
  PROFESSIONISTI = 'professionisti',
}

export enum StatoPratica {
  //FIN
  APERTA = 'APERTA',
  COMPLETATA = 'COMPLETATA',
  DECLINATA = 'DECLINATA',
  DELIBERATA = 'DELIBERATA',
  IN_DELIBERA_CDA = 'IN DELIBERA CDA',
  IN_VALUTAZIONE_FUND = 'IN VALUTAZIONE FUND',
  //AML
  //APERTA = 'APERTA',
  ANNULLATA = 'ANNULLATA',
  //COMPLETATA = 'COMPLETATA',
  IN_AUTORIZZAZIONE = 'IN AUTORIZZAZIONE',
  AUTORIZZATA = 'AUTORIZZATO',
  RIFIUTATA = 'RIFIUTATO',
}

const finPraticaStates: StatoPratica[] = [
  StatoPratica.APERTA,
  StatoPratica.COMPLETATA,
  StatoPratica.DECLINATA,
  StatoPratica.DELIBERATA,
  StatoPratica.IN_DELIBERA_CDA,
  StatoPratica.IN_VALUTAZIONE_FUND,
];

const amlPraticaStates: StatoPratica[] = [
  StatoPratica.APERTA,
  StatoPratica.ANNULLATA,
  StatoPratica.COMPLETATA,
  StatoPratica.IN_AUTORIZZAZIONE,
  StatoPratica.AUTORIZZATA,
  StatoPratica.RIFIUTATA,
];

export const getStatoPraticaOptions = (
  praticaType: PraticaType
): SfSelectOption[] => {
  let options: SfSelectOption[] = [];
  let availablePraticaStates =
    praticaType === 'AML' ? amlPraticaStates : finPraticaStates;
  for (let state of availablePraticaStates) {
    options.push({ value: state, view: state });
  }
  return options;
};

export interface PraticaProgress {
  applicant: number;
  requests: number;
  anagraphics: number;
  score: number;
  presentationSheet: number;
  documents: number;
  total?: number;
}

export type PraticaType = 'FIN' | 'AML';
